var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRenew16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39 4.99986H6V5.99986H2V1.99986H3V3.83986C3.85447 2.8112 5.00541 2.07112 6.29589 1.72053C7.58637 1.36994 8.95358 1.4259 10.2111 1.88079C11.4686 2.33568 12.5552 3.16736 13.3227 4.26241C14.0903 5.35747 14.5014 6.6626 14.5 7.99986H13.5C13.5001 6.81415 13.117 5.66017 12.4078 4.70992C11.6986 3.75967 10.7013 3.06405 9.56462 2.72675C8.4279 2.38944 7.21261 2.42852 6.09991 2.83815C4.98721 3.24777 4.03667 4.00602 3.39 4.99986ZM12.61 10.9998H10V9.99976H14V13.9998H13V12.1598C12.1455 13.1884 10.9946 13.9285 9.70411 14.2791C8.41363 14.6297 7.04642 14.5737 5.78892 14.1188C4.53141 13.6639 3.4448 12.8323 2.67727 11.7372C1.90973 10.6421 1.49863 9.33701 1.5 7.99976H2.5C2.49993 9.18546 2.88303 10.3394 3.59221 11.2897C4.30139 12.2399 5.29867 12.9356 6.43539 13.2729C7.5721 13.6102 8.78739 13.5711 9.90009 13.1615C11.0128 12.7518 11.9633 11.9936 12.61 10.9998Z",
    fill: "#2767A9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenew16);
export default __webpack_public_path__ + "static/media/Renew16.2d7c37e64de426a08b3404f552cdc3be.svg";
export { ForwardRef as ReactComponent };